import { z } from "zod/v4";
export const systemCatalogReorderInputSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("collections"),
        ids: z.array(z.string()),
    }),
    z.object({
        kind: z.literal("taxonomy"),
        parentId: z.string().nullable(),
        ids: z.array(z.string()),
    }),
    z.object({
        kind: z.literal("taxonomy-entries"),
        parentId: z.string().nullable(),
        entries: z.array(z.discriminatedUnion("kind", [
            z.object({ kind: z.literal("taxonomy-node"), id: z.string() }),
            z.object({ kind: z.literal("tile-set"), id: z.string() }),
        ])),
    }),
    z.object({
        kind: z.literal("collection-tile-sets"),
        parentId: z.string(),
        ids: z.array(z.string()),
    }),
    z.object({
        kind: z.literal("taxonomy-tile-sets"),
        parentId: z.string(),
        ids: z.array(z.string()),
    }),
    z.object({
        kind: z.literal("tiles"),
        parentId: z.string(),
        ids: z.array(z.string()),
    }),
    z.object({
        kind: z.literal("tile-set-order-entries"),
        parentId: z.string(),
        entries: z.array(z.discriminatedUnion("kind", [
            z.object({ kind: z.literal("tile"), id: z.string() }),
            z.object({ kind: z.literal("tile-set"), id: z.string() }),
        ])),
    }),
    z.object({
        kind: z.literal("taxonomy-decorations"),
        parentId: z.string().nullable(),
        ids: z.array(z.string()),
    }),
]);
export const systemCatalogDeleteInputSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("collection"), id: z.string() }),
    z.object({ kind: z.literal("taxonomy"), id: z.string() }),
    z.object({
        kind: z.literal("collection-tile-set"),
        parentId: z.string(),
        id: z.string(),
    }),
    z.object({
        kind: z.literal("taxonomy-tile-set"),
        parentId: z.string().nullable(),
        id: z.string(),
    }),
    z.object({ kind: z.literal("tile-set"), id: z.string() }),
    z.object({
        kind: z.literal("tile"),
        id: z.string(),
        parentId: z.string(),
    }),
    z.object({
        kind: z.literal("decoration"),
        id: z.string(),
        parentId: z.string().nullable(),
    }),
]);
export const systemCatalogAttachInputSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("collection"),
        parentId: z.string(),
        tileSetId: z.string(),
    }),
    z.object({
        kind: z.literal("taxonomy"),
        parentId: z.string(),
        tileSetId: z.string(),
    }),
    z.object({
        kind: z.literal("decoration"),
        parentId: z.string().nullable(),
        overlayId: z.string(),
    }),
]);
export const systemCatalogMoveInputSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("taxonomy"),
        id: z.string(),
        targetParentId: z.string().nullable(),
    }),
    z.object({
        kind: z.literal("taxonomy-tile-set"),
        id: z.string(),
        sourceParentId: z.string().nullable(),
        targetParentId: z.string().nullable(),
    }),
]);
export const upsertCatalogTagInputSchema = z.object({
    id: z.string().optional(),
    label: z.string().min(1),
});
export const upsertCollectionInputSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1),
    description: z.string().optional(),
    visibility: z.string().optional(),
});
export const upsertTaxonomyNodeInputSchema = z.object({
    id: z.string().optional(),
    parentId: z.string().nullable().optional(),
    label: z.string().min(1),
    sortOrder: z.number().optional(),
    isOfficial: z.boolean().optional(),
    isDraft: z.boolean().optional(),
    defaultThumbnailTileId: z.string().nullable().optional(),
});
export const upsertOverlayTaxonomyNodeInputSchema = z.object({
    id: z.string().optional(),
    parentId: z.string().nullable().optional(),
    label: z.string().min(1),
    sortOrder: z.number().optional(),
});
const tileSetOrderEntryInputSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("tile"), id: z.string() }),
    z.object({ kind: z.literal("tile-set"), id: z.string() }),
]);
export const saveSystemTileSetInputSchema = z.object({
    tileSetId: z.string().optional(),
    title: z.string().min(1),
    description: z.string().optional(),
    visibility: z.string().optional(),
    enabled: z.boolean().optional(),
    sortOrder: z.number().optional(),
    paintMode: z.enum(["dynamic", "ordered"]).optional(),
    defaultBrowseLabel: z.string().nullable().optional(),
    defaultThumbnailTileId: z.string().nullable().optional(),
    tagIds: z.array(z.string()).optional(),
    tagLabels: z.array(z.string()).optional(),
    collectionIds: z.array(z.string()).optional(),
    taxonomyNodeIds: z.array(z.string()).optional(),
    orderedEntries: z.array(tileSetOrderEntryInputSchema).optional(),
});
export const moveSystemTileInputSchema = z.object({
    tileId: z.string().min(1),
    destinationTileSetId: z.string().min(1),
});
export const saveOverlayPackInputSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1),
    description: z.string().optional(),
    visibility: z.string().optional(),
    enabled: z.boolean().optional(),
    overlayTaxonomyNodeIds: z.array(z.string()).optional(),
    taxonomyNodeIds: z.array(z.string()).optional(),
});
